import { render, staticRenderFns } from "./DeliveriesImport.vue?vue&type=template&id=66aea2d4&"
import script from "./DeliveriesImport.vue?vue&type=script&lang=js&"
export * from "./DeliveriesImport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports